import { mdsColors } from "@/design-system/foundations";
import { css, keyframes } from "@/domains/emotion";
import { memo } from "react";

export interface MdsSpinnerProps {
  size: number;
}

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsSpinner = memo<MdsSpinnerProps>(function MdsSpinner({ size }) {
  return (
    <div className={containerStyles} style={{ height: size, width: size }}>
      <div className={spinnerStyles} />
    </div>
  );
});

const spin = keyframes({
  from: {
    transform: "rotate(0deg)",
  },
  to: {
    transform: "rotate(360deg)",
  },
});

const containerStyles = css({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  position: "relative",
});

const spinnerStyles = css({
  animation: `${spin} 1s linear infinite`,
  border: "2px solid transparent",
  borderRadius: "50%",
  borderTopColor: mdsColors().grey.x600,
  height: "100%",
  maskImage: "linear-gradient(to left, rgba(0,0,0,1) 0%, rgba(0,0,0,0.6) 65%, rgba(0,0,0,0) 100%)",
  width: "100%",
});
